import { z } from 'zod';

export const SignInFormSchema = z.object({
  email: z.string().email('Please enter a valid email.'),
  password: z.string().min(1, 'Password is required.'),
});

export type SignInFormSchemaType = z.infer<typeof SignInFormSchema>;

export const MagicLinkSchema = z.object({
  email: z.string().email('Please enter a valid email.'),
});

export type MagicLinkSchemaType = z.infer<typeof MagicLinkSchema>;
